// FILE: frontend/src/actions/types.js
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL';

export const CREATE_PROFILE_REQUEST = 'CREATE_PROFILE_REQUEST';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';
export const CREATE_PROFILE_FAIL = 'CREATE_PROFILE_FAIL';

export const DELETE_PROFILE_REQUEST = 'DELETE_PROFILE_REQUEST';
export const DELETE_PROFILE_SUCCESS = 'DELETE_PROFILE_SUCCESS';
export const DELETE_PROFILE_FAIL = 'DELETE_PROFILE_FAIL';

export const CREATE_MEDIA_REQUEST = 'CREATE_MEDIA_REQUEST';
export const CREATE_MEDIA_SUCCESS = 'CREATE_MEDIA_SUCCESS';
export const CREATE_MEDIA_FAIL = 'CREATE_MEDIA_FAIL';

export const UPDATE_MEDIA_REQUEST = 'UPDATE_MEDIA_REQUEST';
export const UPDATE_MEDIA_SUCCESS = 'UPDATE_MEDIA_SUCCESS';
export const UPDATE_MEDIA_FAIL = 'UPDATE_MEDIA_FAIL';

export const DELETE_MEDIA_REQUEST = 'DELETE_MEDIA_REQUEST';
export const DELETE_MEDIA_SUCCESS = 'DELETE_MEDIA_SUCCESS';
export const DELETE_MEDIA_FAIL = 'DELETE_MEDIA_FAIL';

export const FETCH_MESSAGES = 'FETCH_MESSAGES';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const FETCH_MEDIAS = 'FETCH_MEDIAS';
export const FETCH_MEDIA_FOR_MESSAGES = 'FETCH_MEDIA_FOR_MESSAGES';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

// Profile Media Actions
export const CREATE_PROFILEMEDIA_REQUEST = 'CREATE_PROFILEMEDIA_REQUEST';
export const CREATE_PROFILEMEDIA_SUCCESS = 'CREATE_PROFILEMEDIA_SUCCESS';
export const CREATE_PROFILEMEDIA_FAIL = 'CREATE_PROFILEMEDIA_FAIL';

export const FETCH_PROFILEMEDIA_REQUEST = 'FETCH_PROFILEMEDIA_REQUEST';
export const FETCH_PROFILEMEDIA_SUCCESS = 'FETCH_PROFILEMEDIA_SUCCESS';
export const FETCH_PROFILEMEDIA_FAIL = 'FETCH_PROFILEMEDIA_FAIL';

export const UPDATE_PROFILEMEDIA_REQUEST = 'UPDATE_PROFILEMEDIA_REQUEST';
export const UPDATE_PROFILEMEDIA_SUCCESS = 'UPDATE_PROFILEMEDIA_SUCCESS';
export const UPDATE_PROFILEMEDIA_FAIL = 'UPDATE_PROFILEMEDIA_FAIL';

// Profile Info Actions
export const CREATE_PROFILEINFO_REQUEST = "CREATE_PROFILEINFO_REQUEST";
export const CREATE_PROFILEINFO_SUCCESS = "CREATE_PROFILEINFO_sUCCESS";
export const CREATE_PROFILEINFO_FAIL = "CREATE_PROFILEINFO_FAIL";;

export const FETCH_PROFILEINFO_REQUEST = 'FETCH_PROFILEINFO_REQUEST';
export const FETCH_PROFILEINFO_SUCCESS = 'FETCH_PROFILEINFO_SUCCESS';
export const FETCH_PROFILEINFO_FAIL = 'FETCH_PROFILEINFO_FAIL';

export const UPDATE_PROFILEINFO_REQUEST = 'UPDATE_PROFILEINFO_REQUEST';
export const UPDATE_PROFILEINFO_SUCCESS = 'UPDATE_PROFILEINFO_SUCCESS';
export const UPDATE_PROFILEINFO_FAIL = 'UPDATE_PROFILEINFO_FAIL';


